const isDev: Boolean = 
  process.env.NODE_ENV === 'development' || 
  // true
  false
  

export default isDev
